import { ca } from '@cian/analytics';

export function trackAuthenticateMotivationShow(customPageURL: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'syncFavorites_popup',
    action: 'show',
    label: customPageURL,
    useLastProducts: true,
  });
}

export function trackAuthenticateMotivationClose() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'syncFavorites_popup',
    action: 'click_JK',
    label: 'close',
    useLastProducts: true,
  });
}

export function trackAuthenticateMotivationLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'syncFavorites_popup',
    action: 'click_JK',
    label: 'goToLK',
    useLastProducts: true,
  });
}
